import React from "react";

export default function Mensaje151001() {
  return (
    <>
      <p>
        <h6>15 de octubre de 2001</h6>
        <br />
        <p>
          Amados hijitos: <br />
          En estos días El Señor os colma de gracias especiales, imposibles de
          experimentar, sin abrir el corazón;<strong> sin orar.</strong>
          <br />
          Deseo ayudarlos a recibir estas <strong>Gracias de Dios.</strong>
          <br />
          <strong>
            Es necesario que dispongáis de tiempo para la oración.
          </strong>{" "}
          ¡Oren con el corazón!.
          <br />
          <strong>
            <i>Orar con el corazón:</i>
          </strong>{" "}
          Es querer amar a Dios sobre todas las cosas.
          <br />
          <strong>
            <i>Orar con el corazón:</i>
          </strong>{" "}
          Es encontrarse con Dios y solo con El.
          <br />
          <strong>
            <i>Orar con el corazón:</i>
          </strong>{" "}
          Es tener conciencia de hacer esto. Alaben a Dios por su inmenso Amor;
          no se detengan en la adversidad.
          <br />
          Caminen de mi Mano.
          <br />
          Os amo cada día más con intenso amor. Benditos sean.
          <br />
          Amén. Amén. Amén.
        </p>
      </p>
    </>
  );
}
